import { graphql } from '~/lib/graphql'

export const ReserveSuccess = graphql(`
  fragment ReserveSuccess on ReserveOk {
    reservation {
      reservationId
      restaurant {
        name
      }
      visitDate
      visitTime
      visitorsCount
    }
    firstTimeReserve
    affiliateSiteConversionTag
  }
`)
